module.exports = __webpack_public_path__ + "img/kommune-1911.4b73a813.svg";